/**
	Move an array item to a different position.
	@param array - The array to move the item in.
	@param from - Index of item to move. If negative, it will begin that many elements from the end.
	@param to - Index of where to move the item. If negative, it will begin that many elements from the end.
 * @param numberOfItems
	@returns A new array with the item moved to the new position.
 
	@example
	```
	const input = ['a', 'b', 'c'];
 
	arrayMove(input, 1, 2);
	//=> ['a', 'c', 'b']
 
	arrayMove(input, -1, 0);
	//=> ['c', 'a', 'b']
 
	arrayMove(input, -2, -3);
	//=> ['b', 'a', 'c']
	```
 */
export const arrayMoveMutate = (array, from, to, numberOfItems = 1) => {
	const startIndex = to < 0 ? array.length + to : to;
	const items = array.splice(from, numberOfItems);
	array.splice(startIndex, 0, ...items);
};

const arrayMove = (array, from, to, numberOfItems = 1) => {
	array = array.slice();
	arrayMoveMutate(array, from, to, numberOfItems);
	return array;
};

export default arrayMove;
